(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lilliput-optional-extras"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-optional-extras] .ld-extras__more').forEach((link) => {
    link.addEventListener(
      'click',
      (event) => {
        const checkbox = link.closest('.ld-extras__row')?.querySelector('.ld-extras__checkbox');
        if (!checkbox) return;
        const wasChecked = checkbox.checked;
        event.stopPropagation();
        requestAnimationFrame(() => {
          if (checkbox.checked !== wasChecked) checkbox.checked = wasChecked;
        });
      },
      true
    );
  });
  } catch(e) { console.error(e); }
})();

})();
